// extracted by mini-css-extract-plugin
module.exports = {"tabs":"BottomTabs_tabs__sbFVR"};